module.exports = __webpack_public_path__ + "media/src/images/top_text-e7be92ed23e0f63c82fddea6e151a2b3.svg";